import { useState, useCallback } from 'react';
import * as Toast from '../components/ui/Toast';

let toastId = 0;

export function useToast() {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((toast) => {
    const id = toastId++;
    const newToast = { ...toast, id, open: true };
    setToasts((prev) => [...prev, newToast]);

    // Errors remain until dismissed; success toasts auto-dismiss after 2 seconds
    if (toast.type !== 'error') {
      const duration = toast.duration ?? 2000;
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, duration);
    }

    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const success = useCallback((title, description, duration) => {
    return addToast({ type: 'success', title, description, duration });
  }, [addToast]);

  const error = useCallback((title, description, duration) => {
    return addToast({ type: 'error', title, description, duration });
  }, [addToast]);

  const ToastContainer = () => (
    <Toast.ToastProvider>
      <Toast.ToastViewport />
      {toasts.map((toast) => {
        const ToastComponent = toast.type === 'error' ? Toast.ToastError : Toast.ToastSuccess;
        return (
          <ToastComponent
            key={toast.id}
            title={toast.title}
            description={toast.description}
            open={toast.open}
            onOpenChange={(open) => {
              if (!open) {
                removeToast(toast.id);
              }
            }}
          />
        );
      })}
    </Toast.ToastProvider>
  );

  return {
    success,
    error,
    ToastContainer,
  };
}

